import analytics from '@finn-no/analytics';

import { commonTrackingInfo } from './commonTracking.js';

const CHEAPEST = 'Pricetype:Cheapest-price-flight';
const OTHER_PRICES = 'Pricetype:all-other-prices-flight';

function priceAsNumber(priceFromElement) {
    if (!priceFromElement) {
        return 0;
    }
    return isNaN(+priceFromElement) ? 0 : +priceFromElement;
}

export function trackToggleCalendar(cellsWithPrice, request) {
    analytics.trackEvent({
        analyticsName: 'purchase-travel.open-flight-calendar.click',
        numberValue: +cellsWithPrice,
        context: commonTrackingInfo(request),
    });
}

export function trackCalendarNotAvailable(request) {
    analytics.trackEvent({
        analyticsName: 'other.calendar-not-available.not-shown',
        context: commonTrackingInfo(request),
    });
}

export function trackCalendarSearch(request, fromdate, todate, price, cheapest) {
    const trackingInfo = Object.assign({}, request, { fromdate, todate });
    analytics.trackEvent({
        analyticsName: 'purchase-travel.clicks-flight-calendar-price.select',
        numberValue: priceAsNumber(price),
        stringValue: cheapest ? CHEAPEST : OTHER_PRICES,
        context: trackingInfo,
    });
}
